module.exports = __webpack_public_path__ + "static/media/anniu3.affeb6c0.png";